import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const ChapterHeader = ({ number, eyebrow, title, light = false }) => (
  <Reveal>
    <div className="flex items-end gap-5 mb-6">
      <span
        className="font-serif italic text-6xl md:text-7xl leading-none text-pawc-terra"
        aria-hidden="true"
      >
        {number}
      </span>
      <div className="pb-2">
        <p
          className={`text-xs md:text-sm font-sans tracking-[0.28em] uppercase mb-2 ${
            light ? "text-pawc-mist/80" : "text-pawc-teal"
          }`}
        >
          {eyebrow}
        </p>
        <h2
          className={`font-serif text-4xl md:text-5xl tracking-tight leading-tight ${
            light ? "text-pawc-sand" : "text-pawc-deep"
          }`}
        >
          {title}
        </h2>
      </div>
    </div>
  </Reveal>
);
